/* 컬렉션 목록 무한 스크롤 — 페이지 번호 대신 스크롤로 다음 쪽을 이어 붙인다.
 *
 * ⚠️⚠️ **페이지네이션 마크업을 지우지 않는다.** JS 가 죽거나 꺼진 환경에서는 그게 유일한
 *    이동 수단이라, 여기서 **JS 로 감춘다**(CSS 로 감추면 no-JS 에서도 사라진다).
 * ⚠️ 서버 페이지네이션(`paginate`)을 그대로 쓴다 — 다음 쪽 주소는 `rel="next"` 링크에서 읽는다.
 *    별도 API 를 만들지 않으므로 필터·정렬 파라미터가 그대로 따라온다.
 * ⚠️⚠️ **필터를 바꾸면 `facets.js` 가 `#ProductGridContainer` 의 innerHTML 을 통째로 갈아끼운다.**
 *    그러면 우리 감시자·센티넬이 사라진 노드를 붙들게 되므로 컨테이너에 MutationObserver 를
 *    걸어 **다시 붙인다**. 이걸 빼면 "필터를 한 번 쓰면 무한 스크롤이 조용히 죽는" 상태가 된다.
 * ⚠️ 이어 붙일 때 `<li>` 만 옮긴다 — 다음 쪽 HTML 의 `#product-grid` 자체를 넣으면 id 가 둘이 된다.
 *
 * ⚠️⚠️ **주소를 다음 쪽으로 바꾸지 않는다 — 뒤로가기가 깨진다(2026-09-10 제보).**
 *    예전엔 한 쪽을 이어 붙일 때마다 `history.replaceState` 로 주소를 `?page=N` 으로 바꿨다.
 *    `replaceState` 는 **지금 있는 history 항목의 주소를 고치는 것**이라, 상품 상세로 들어갔다
 *    뒤로 오면 브라우저가 그 `?page=N` 문서를 새로 그린다(bfcache 가 살아 있을 때만 원래
 *    화면이 돌아온다 — iOS 는 메모리 사정으로 자주 버린다). 그러면 ㉠ 앞쪽 쪽들이 사라져
 *    **마지막으로 본 화면이 아니고** ㉡ 마지막 쪽이면 `data-nt-next` 가 비어 있어 아래 초기화가
 *    조기 return 하므로 **페이지네이션이 그대로 보인다**(둘 다 제보된 증상이다).
 *    → 주소는 그대로 두고 **불러온 쪽 수와 스크롤 위치를 `sessionStorage` 에 적어** 두었다가
 *      뒤로 왔을 때 그 지점까지 다시 이어 붙인다(`restore`).
 *
 * ⚠️⚠️ **뒤로 왔으면 이전에 본 상품이 "기다림 없이" 그대로 있어야 한다(2026-09-10 지시).**
 *    요청을 병렬로 바꿔 3배 빨라져도(실측 3,259ms → 1,098ms) **기다림은 여전히 보인다** —
 *    화면은 하단에 붙어 있는데 상품이 없고, 로드가 끝난 뒤에야 위치가 맞춰진다. 그래서
 *    **불러온 쪽의 HTML 자체를 `sessionStorage` 에 캐시**해 두고 뒤로 왔을 때 **네트워크 0으로
 *    동기 삽입**한다(첫 페인트 전에 끝나 사용자는 아무것도 못 본다).
 *    ▸ 실측 크기: 상품 1개 5.6KB · 55개 **약 301KB** · `sessionStorage` 여유 **6MB+**.
 *    ▸ 이미지는 브라우저 HTTP 캐시에서 나오므로 다시 받지 않는다.
 *    ▸ 캐시가 없는 쪽만 병렬로 받는다 — 캐시가 비면 옛 동작으로 안전하게 내려간다.
 * ⚠️⚠️ **bfcache 를 기대하지 말 것 — 우리가 통제할 수 없다.** 실측(Chrome
 *    `notRestoredReasons`): 뒤로 왔을 때 `back_forward` 인데 bfcache 는 **miss** 이고 사유가
 *    `"masked"` 였다(브라우저가 가리는 사유 = 크로스오리진 프레임·서드파티 스크립트 계열).
 *    테마 코드로 풀 수 있는 문제가 아니다 — 그래서 위 캐시가 유일하게 확실한 답이다.
 * ⚠️⚠️ **복원은 `back_forward` 내비게이션에서만 한다**(Navigation Timing 의 `type`).
 *    안 그러면 메뉴에서 컬렉션을 새로 눌러 들어왔을 때도 옛 위치로 끌려간다.
 *    그 API 가 없는 브라우저에서는 **복원하지 않는다**(모르면 아무 것도 하지 않는 쪽이 안전하다).
 */
(function () {
  if (window.__ntInfinite) return;
  window.__ntInfinite = true;

  var ROOT_MARGIN = '600px 0px'; /* 화면에 닿기 전에 미리 불러 끊김을 줄인다 */
  var MAX_RESTORE_PAGES = 10; /* 복원 때 재요청 상한 — 아주 깊이 내려간 뒤 돌아온 경우의 안전선 */
  var RESTORE_CONCURRENCY = 4; /* 동시 요청 수 — 한꺼번에 다 던지면 Shopify 가 조인다 */
  var SAVE_TTL_MS = 30 * 60 * 1000; /* 30분이면 낡은 위치다 — 그때는 처음부터 본다 */

  /* 주소(필터·정렬 포함)마다 따로 기억한다 — 필터를 바꾸면 다른 목록이므로 위치도 다르다. */
  function storeKey() {
    return 'nt-inf:' + window.location.pathname + window.location.search;
  }

  function readSaved() {
    try {
      var raw = window.sessionStorage.getItem(storeKey());
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.p || Date.now() - (v.t || 0) > SAVE_TTL_MS) return null;
      return v;
    } catch (e) {
      return null;
    }
  }

  /* bfcache 로 떠나 있는 동안엔 위치를 적지 않는다 — 돌아올 때 Safari 가 0으로 둔 순간의
     scroll 이벤트가 저장값을 덮는다(아래 `pageshow` 주석 참조). */
  var frozen = false;

  function writeSaved(pages, y) {
    if (frozen) return;
    try {
      window.sessionStorage.setItem(
        storeKey(),
        JSON.stringify({ p: pages, y: Math.round(y), t: Date.now() })
      );
    } catch (e) {}
  }

  /* ── 쪽 HTML 캐시 ────────────────────────────────────────────────
     ⚠️ **쪽 단위로** 저장한다 — 목록 전체를 한 값에 담으면 쪽을 더할 때마다 300KB 를 다시
        직렬화한다.
     ⚠️ `n`(그 쪽의 다음 주소)을 함께 담는다 — 없으면 마지막 쪽인지 몰라 복원 뒤에
        페이지네이션을 감출지 판단할 수 없다.
     ⚠️ 용량이 넘치면(`QuotaExceededError`) **조용히 포기**한다 — 캐시는 부가 기능이고 없으면
        그 쪽만 네트워크로 받는다. */
  function htmlKey(page) {
    return 'nt-inf-h:' + window.location.pathname + window.location.search + ':' + page;
  }

  function readHtml(page) {
    try {
      var raw = window.sessionStorage.getItem(htmlKey(page));
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.h || Date.now() - (v.t || 0) > SAVE_TTL_MS) return null;
      return v;
    } catch (e) {
      return null;
    }
  }

  function writeHtml(page, html, next) {
    try {
      window.sessionStorage.setItem(
        htmlKey(page),
        JSON.stringify({ h: html, n: next || '', t: Date.now() })
      );
    } catch (e) {}
  }

  /* ⚠️ 뒤로·앞으로 온 것인지 판정한다. `performance.navigation`(구형)은 쓰지 않는다 —
     iOS 에서 값이 신뢰할 수 없고, 없으면 복원을 안 하는 쪽으로 떨어지면 된다. */
  /* ⚠️⚠️ **`reload` 도 복원 대상이다 — `snippets/neoteria-infinite-restore.liquid` 가
     복원하는 동안 `history.scrollRestoration` 을 `manual` 로 돌려 브라우저 복원을 끄기 때문이다.**
     안 넣으면 새로고침이 맨 위로 간다(브라우저가 해 주던 일이 사라진 회귀).
     ⚠️ 그 스니펫의 판정과 **같은 집합**이어야 한다 — 한쪽만 고치면 인라인이 붙인 쪽을
     이쪽이 모르거나 그 반대가 된다. */
  function isBackNav() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (!nav) return false;
      return nav.type === 'back_forward' || nav.type === 'reload';
    } catch (e) {
      return false;
    }
  }

  function setup(container) {
    var grid = container.querySelector('#product-grid');
    if (!grid || grid.dataset.ntInfinite === '1') return;

    var pagination = container.querySelector('.pagination-wrapper');
    /* ⚠️ 주소는 섹션이 심어 준 `data-nt-next` 에서 읽는다 — Dawn 의 화살표 클래스는
       이름과 방향이 반대라(`--next` 가 이전 링크다) 믿을 수 없다. */
    var meta = container.querySelector('.nt-infinite');
    var nextUrl = meta ? meta.getAttribute('data-nt-next') : '';

    /* ⚠️⚠️ **인라인 복원(`snippets/neoteria-infinite-restore.liquid`)이 이미 붙였을 수 있다.**
       그쪽은 첫 페인트를 놓치지 않으려고 파싱 중에 캐시로 붙이고, 몇 쪽까지 붙였는지와
       그 쪽의 다음 주소를 `data-nt-restored*` 로 남긴다. 그걸 안 읽으면 여기서
       **1쪽부터 다시** 세어 같은 쪽을 또 받는다. */
    var restored = parseInt(grid.getAttribute('data-nt-restored') || '', 10);
    if (restored > 1) {
      nextUrl = grid.getAttribute('data-nt-restored-next') || '';
    }

    if (!nextUrl && !(restored > 1)) return; /* 한 쪽뿐이면 할 일이 없다 */

    grid.dataset.ntInfinite = '1';
    if (pagination) pagination.style.display = 'none';

    var pagesLoaded = restored > 1 ? restored : 1;

    var sentinel = document.createElement('div');
    sentinel.className = 'nt-infinite__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    grid.insertAdjacentElement('afterend', sentinel);

    /* ── 로딩 표시 ─────────────────────────────────────────────────
       ⚠️⚠️ **센티넬에 높이를 주지 말 것** — 예전엔 `is-loading` 으로 센티넬을 1px → 48px 로
          키워 점을 그렸다. 그건 **관찰 대상을 관찰 중에 움직이는 것**이라 교차 판정이
          다시 걸려 불필요한 요청을 부를 수 있다. 표시는 별도 형제로 분리한다.
       ⚠️ 카페24 `#loadingArea` 를 참고했다(지시) — 마크업이
          `.loading_area > .loading > .loading_spiner > span.spiner` 이고 점 세 개다.
          우리는 같은 모양을 점 3개(`<span>`)로 만든다(자세한 실측은 CSS 주석). */
    var loader = document.createElement('div');
    loader.className = 'nt-loading';
    /* ⚠️⚠️ **로더 자체가 `role="status"` 다 — 빈 `aria-live` div 를 따로 두지 말 것.**
       예전엔 `.nt-infinite__status` 를 만들어 놓고 **텍스트를 한 번도 넣지 않았다**(죽은
       요소였다). 게다가 그것도 빈 `div` 라 아래 `div:empty` 함정에 걸려 숨겨졌다.
       ⚠️ 점 세 개는 `aria-hidden` — 낭독할 내용이 아니다. 문구는 `aria-label` 이 맡는다.
       ⚠️ 문구는 섹션이 `data-nt-loading` 으로 넘긴다(`assets/*.js` 에선 `| t` 를 못 쓴다). */
    loader.setAttribute('role', 'status');
    loader.setAttribute('aria-live', 'polite');
    var loadingText = meta ? meta.getAttribute('data-nt-loading') : '';
    if (loadingText) loader.setAttribute('aria-label', loadingText);
    for (var d = 0; d < 3; d++) {
      var dot = document.createElement('span');
      dot.setAttribute('aria-hidden', 'true');
      loader.appendChild(dot);
    }
    sentinel.insertAdjacentElement('afterend', loader);

    function showLoader(on) {
      loader.classList.toggle('is-on', !!on);
    }

    var loading = false;

    /* ⚠️ promise 를 돌려준다 — 복원은 쪽을 **순서대로** 이어 붙여야 하고(다음 주소가 그
       쪽 HTML 안에 있다) 그러려면 앞 요청이 끝난 뒤에 다음을 걸어야 한다. */
    function load() {
      if (loading || !nextUrl) return Promise.resolve(false);
      loading = true;
      showLoader(true);

      return fetch(nextUrl)
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.getElementById('product-grid');
          if (!nextGrid) throw new Error('no grid');

          /* ⚠️ **자식을 옮기기 전에** HTML 을 읽는다 — 옮긴 뒤엔 `innerHTML` 이 빈 문자열이다. */
          var pageHtml = nextGrid.innerHTML;
          var nextMeta = doc.querySelector('.nt-infinite');
          var nextOfPage = nextMeta ? nextMeta.getAttribute('data-nt-next') : '';

          var items = nextGrid.children;
          var frag = document.createDocumentFragment();
          while (items.length) frag.appendChild(items[0]);
          grid.appendChild(frag);

          pagesLoaded += 1;
          writeHtml(pagesLoaded, pageHtml, nextOfPage);
          nextUrl = nextOfPage;

          /* ⚠️ 여기서 `history.replaceState` 로 주소를 바꾸지 말 것(파일 상단 주석 참조) —
             뒤로 왔을 때 `?page=N` 문서가 새로 그려져 앞쪽 쪽들과 스크롤 위치를 잃는다. */
          writeSaved(pagesLoaded, window.scrollY);

          if (!nextUrl) {
            observer.disconnect();
            sentinel.remove();
            loader.remove();
          }
        })
        .catch(function () {
          /* ⚠️ 실패하면 감시를 멈추고 **페이지네이션을 되살린다** — 아무 일도 안 일어나는
             화면보다 번호를 눌러 넘길 수 있는 화면이 낫다. */
          observer.disconnect();
          sentinel.remove();
          loader.remove();
          if (pagination) pagination.style.display = '';
        })
        .then(function () {
          loading = false;
          showLoader(false);
          return true;
        });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) load();
      },
      { rootMargin: ROOT_MARGIN }
    );
    observer.observe(sentinel);

    /* ⚠️ 스크롤 보조 트리거 — IntersectionObserver 가 **멈추는 환경**이 있다(인앱 브라우저의
       공격적인 스로틀, 백그라운드 탭에서 돌아온 직후 등). 그때 화면은 "끝까지 내렸는데
       아무 일도 안 일어나는" 상태가 된다. 값이 같은 조건을 스크롤에서 한 번 더 본다.
       ⚠️ `load()` 가 자체적으로 `loading` 을 보고 중복을 막으므로 둘이 같이 불려도 안전하다.
       ⚠️ `passive` 로 붙여 스크롤을 막지 않는다. */
    var pending = false;
    function onScroll() {
      /* ⚠️ 스크롤할 때마다 위치를 적어 둔다 — 상품을 누르는 순간을 따로 잡지 않아도
         마지막 위치가 남는다(`click` 을 가로채면 새 탭·키보드 이동을 놓친다). */
      writeSaved(pagesLoaded, window.scrollY);
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        if (!sentinel.isConnected) return;
        var top = sentinel.getBoundingClientRect().top;
        if (top - window.innerHeight < 600) load();
      }, 150);
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ── 뒤로 왔을 때 보던 지점까지 되돌린다 ─────────────────────────
       ⚠️ bfcache 가 살아 있으면 이 코드는 아예 안 돈다(문서가 그대로 복원된다) — 그때가
          가장 좋은 결과이고, 여기는 **bfcache 를 놓친 경우**의 보정이다.
       ⚠️ 상한(`MAX_RESTORE_PAGES`)을 두어 아주 깊은 위치에서 돌아왔을 때 요청이 폭주하지
          않게 한다. 받는 방식은 아래 `restore` 주석 참조(순차 체인이 아니라 병렬이다).
       ⚠️ 스크롤 복원은 **이어 붙인 뒤**에 한다 — 먼저 옮기면 문서가 짧아 그 위치가 없다. */
    var saved = isBackNav() ? readSaved() : null;
    if (saved && saved.p > 1) restore(saved);

    /* ── 복원 = 쪽 주소를 직접 만들어 **병렬로** 받는다 ────────────────────────
       ⚠️⚠️ 순차 체인으로 되돌리지 말 것(2026-09-10 제보: "오래 기다려야 이전 화면이 나온다").
          다음 주소를 각 쪽 HTML 안에서 읽느라 한 쪽씩 기다렸는데, 쪽당 실측 **0.4~0.47초**라
          4쪽까지 봤으면 그 대기가 그대로 쌓인다(모바일 회선이면 몇 배). 주소는 `?page=N` 이라
          **예측할 수 있으므로** 기다릴 이유가 없다.
       ⚠️ 필터·정렬 파라미터는 지금 주소에 이미 들어 있다 — `URLSearchParams` 로 `page` 만
          갈아 끼워야 그게 보존된다(주소를 새로 조립하면 필터가 날아간다).
       ⚠️ 한꺼번에 다 던지지 않는다(`RESTORE_CONCURRENCY`) — 조이면 일부가 실패해 오히려 느리다.
       ⚠️ **순서대로 이어 붙인다** — 병렬로 받아도 붙이는 건 쪽 번호 순이어야 목록이 안 섞인다.
       ⚠️ 하나라도 실패하면 **거기서 멈추고** 나머지는 평소 무한 스크롤에 맡긴다(빈 자리를
          남기며 뒤쪽만 붙이면 목록이 거짓이 된다). */
    function pageUrl(n) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(n));
      return u.pathname + u.search;
    }

    /* 캐시된 HTML 을 목록에 붙인다. 실패하면 false — 그 쪽은 네트워크로 받는다.
       ⚠️⚠️ **복원으로 붙이는 카드는 등장 애니메이션을 끈다(2026-09-10 제보로 확정).**
          테마 설정 `animations_reveal_on_scroll` 이 켜져 있어 카드마다
          `scroll-trigger animate--slide-in` 이 붙는다. 실측한 카드 상태 —
          `opacity: 0.01` · `translateY(20px)` · `animation: slideIn … forwards`,
          `--animation-order` 가 1..16 이라 `delay = order × 75ms` = **최대 1.2초**.
          그래서 뒤로 왔을 때 DOM 에는 상품이 다 있는데도 **아래에서 위로 올라오며
          뒤늦게** 나타난다(제보: "아래에서 위로 올라오는 애니메이션 때문인가" — 맞다).
          `scroll-trigger` 만 떼면 CSS 선택자(`.scroll-trigger.animate--slide-in`)가
          안 걸려 **즉시 제자리에 보인다.**
       ⚠️ **평소 무한 스크롤 삽입에는 그대로 둔다** — 내려가며 보는 연출이라 의도된 것이다.
          그래서 이 끄기는 `strip` 인자로 **복원 경로에서만** 켠다. */
    function appendHtml(html, next, strip) {
      var doc = new DOMParser().parseFromString(
        '<ul id="nt-tmp">' + html + '</ul>',
        'text/html'
      );
      var box = doc.getElementById('nt-tmp');
      if (!box || !box.children.length) return false;
      if (strip) {
        box.querySelectorAll('.scroll-trigger').forEach(function (el) {
          el.classList.remove('scroll-trigger');
        });
      }
      var frag = document.createDocumentFragment();
      while (box.children.length) frag.appendChild(box.children[0]);
      grid.appendChild(frag);
      pagesLoaded += 1;
      nextUrl = next || '';
      return true;
    }

    function finishRestore(y) {
      loading = false;
      showLoader(false);
      if (!nextUrl) {
        observer.disconnect();
        if (sentinel.isConnected) sentinel.remove();
        if (loader.isConnected) loader.remove();
      }
      writeSaved(pagesLoaded, y);
      if (y > 0) window.scrollTo(0, y);
    }

    function restore(state) {
      var want = Math.min(state.p, 1 + MAX_RESTORE_PAGES);

      /* ── ① 캐시로 즉시(동기) 복원 ─────────────────────────────
         ⚠️ **연속으로** 있는 쪽까지만 붙인다 — 중간이 비었는데 뒤쪽만 붙이면 목록 순서가
            거짓이 된다(3쪽이 없는데 4쪽을 붙이면 사용자가 못 본 상품이 끼어든다).
         ⚠️ 여기서 `await`·`fetch` 를 쓰지 말 것 — 동기라서 첫 페인트 전에 끝나고,
            그게 "기다림 없이 그대로"의 유일한 조건이다. */
      while (pagesLoaded < want) {
        var hit = readHtml(pagesLoaded + 1);
        if (!hit) break;
        if (!appendHtml(hit.h, hit.n, true)) break;
      }

      /* 캐시로 다 채웠으면 네트워크는 아예 건드리지 않는다. */
      if (pagesLoaded >= want || !nextUrl) {
        finishRestore(state.y);
        return;
      }

      /* ── ② 남은 쪽만 병렬로 받는다 ─────────────────────────────
         ⚠️⚠️ 순차 체인으로 되돌리지 말 것(2026-09-10 제보). 다음 주소를 각 쪽 HTML 에서
            읽느라 한 쪽씩 기다렸는데 쪽당 실측 0.4~0.47초라 그대로 쌓인다. 주소는 `?page=N`
            이라 **예측할 수 있으므로** 기다릴 이유가 없다.
         ⚠️ 필터·정렬은 지금 주소에 이미 있다 — `URLSearchParams` 로 `page` 만 갈아 끼워야
            보존된다(주소를 새로 조립하면 필터가 날아간다).
         ⚠️ 한꺼번에 다 던지지 않는다(`RESTORE_CONCURRENCY`) — 조이면 일부가 실패해 더 느리다.
         ⚠️ **순서대로** 붙이고, 하나라도 실패하면 거기서 멈춘다(나머지는 무한 스크롤에 맡긴다). */
      var pages = [];
      for (var p = pagesLoaded + 1; p <= want; p++) pages.push(p);

      loading = true; /* 복원 중에는 센티넬이 끼어들지 않게 막는다 */
      showLoader(true);

      var htmls = new Array(pages.length);
      var idx = 0;

      function worker() {
        if (idx >= pages.length) return Promise.resolve();
        var my = idx++;
        return fetch(pageUrl(pages[my]))
          .then(function (r) {
            if (!r.ok) throw new Error(String(r.status));
            return r.text();
          })
          .then(function (html) {
            htmls[my] = html;
            return worker();
          })
          .catch(function () {
            htmls[my] = null;
            return worker();
          });
      }

      var lanes = [];
      for (var i = 0; i < Math.min(RESTORE_CONCURRENCY, pages.length); i++) {
        lanes.push(worker());
      }

      Promise.all(lanes).then(function () {
        for (var k = 0; k < htmls.length; k++) {
          if (!htmls[k]) break; /* 끊긴 지점에서 중단 */
          var doc = new DOMParser().parseFromString(htmls[k], 'text/html');
          var nextGrid = doc.getElementById('product-grid');
          if (!nextGrid) break;
          var pageHtml = nextGrid.innerHTML;
          var meta2 = doc.querySelector('.nt-infinite');
          var nextOfPage = meta2 ? meta2.getAttribute('data-nt-next') : '';
          if (!appendHtml(pageHtml, nextOfPage, true)) break;
          /* 다음에 뒤로 왔을 때는 네트워크 없이 복원되도록 캐시에 남긴다. */
          writeHtml(pagesLoaded, pageHtml, nextOfPage);
        }
        finishRestore(state.y);
      });
    }
  }

  /* ⚠️⚠️ **뒤로 온 화면에서는 등장 애니메이션을 통째로 끈다(2026-09-10 지시).**
     "이미 불러왔던 상품은 불러와져 있는 상태 그대로" 여야 하는데, 테마 설정
     `animations_reveal_on_scroll` 때문에 **서버가 준 첫 쪽 카드까지** 다시
     `opacity: 0.01` → `translateY(20px)` 에서 올라온다(실측 첫 쪽 16장이 그 상태).
     복원분만 끄면 스크롤이 얕았던 경우엔 여전히 밑에서 올라온다.
     ⚠️ **범위를 `#ProductGridContainer` 로 한정한다** — 배너 등 다른 섹션의 연출까지 끄면
     과하다. ⚠️ 컨테이너 **자신도** `scroll-trigger` 를 갖는다(그리드 전체가 함께 올라온다).
     ⚠️ 새로 들어온 경우(`navigate`)엔 그대로 둔다 — 그건 의도된 연출이다. */
  function stripReveal(container) {
    if (container.classList.contains('scroll-trigger')) {
      container.classList.remove('scroll-trigger');
    }
    container.querySelectorAll('.scroll-trigger').forEach(function (el) {
      el.classList.remove('scroll-trigger');
    });
  }

  /* ⚠️⚠️ **bfcache 복원도 우리가 위치를 맞춘다(2026-09-27 제보: EU몰 iPhone Safari 에서만
     뒤로가기가 최상단).** bfcache 로 돌아오면 문서가 다시 파싱되지 않아 인라인 복원
     (`neoteria-infinite-restore`)이 돌지 않는다. 그런데 그 스니펫이 켠
     `scrollRestoration = 'manual'` 은 그대로라 **Safari 는 위치를 0으로 둔다**(Chrome 은 유지).
     테마 코드는 3몰이 같다 — EN 은 Channel Talk·CornerCart 앱 때문에 bfcache 에 안 들어가
     늘 새로 로드되는 것으로 **추정**한다(EU 엔 두 앱이 없다). 즉 앱 구성에 따라 몰마다 갈린다.
     ⚠️ 위치는 `pagehide` 시점의 메모리 값을 쓴다 — 복원 순간의 scroll 이벤트가 저장값을
        0으로 덮을 수 있어 그때까지 `frozen` 으로 기록을 멈춘다.
     ⚠️ Safari 가 복원 뒤 한 프레임 늦게 다시 0으로 둘 수 있어 두 프레임 더 확인한다. */
  function bindBfcache() {
    var hiddenY = 0;
    window.addEventListener('pagehide', function (e) {
      if (!e.persisted) return;
      hiddenY = window.scrollY;
      frozen = true;
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var y = hiddenY;
      if (!(y > 0)) {
        var s = readSaved();
        y = s ? s.y : 0;
      }
      function fix() {
        if (y > 0 && Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
      }
      fix();
      requestAnimationFrame(function () {
        fix();
        requestAnimationFrame(function () {
          fix();
          frozen = false;
        });
      });
    });
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (isBackNav()) stripReveal(container);
    bindBfcache();
    setup(container);

    new MutationObserver(function () {
      setup(container);
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
